import Service from "../Service";

const resource = "/person";

export default {
  /**
   * Guardar email de persona
   * @param {Object} obj - Objeto GenPersonEmail
   * @param {number} requestID - ID del usuario
   */
  save(obj, requestID) {
    return Service.post(`${resource}/email/save`, obj, {
      params: { requestID }
    });
  }
};
